import {Link} from '@shopify/hydrogen';
import {resolvePath} from '~/lib/utils';

function InternalLink({
  documentType,
  slug,
  className,
  children,
  onClick,
}: {
  documentType: string;
  slug: string;
  className?: string;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}) {
  const path = resolvePath(documentType, slug);

  return path ? (
    <Link to={path} className={className} onClick={onClick}>
      {children}
    </Link>
  ) : null;
}

export {InternalLink};
